// analytics.js
// Simple analytics event logger
import { getBackendURL } from "./utils";

function getSessionId() {
  let sessionId = localStorage.getItem('ptc_session_id');
  if (!sessionId) {
    sessionId = Math.random().toString(36).substr(2, 16) + Date.now().toString(36);
    localStorage.setItem('ptc_session_id', sessionId);
  }
  return sessionId;
}

export function logEvent(eventName, eventData = {}) {

    // Note - remember to stay environment agnostic.


  const sessionId = getSessionId();
  const ptcAccessToken = localStorage.getItem('ptc_access_token');
  fetch(getBackendURL() + '/analytics_event', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      
    },
    body: JSON.stringify({
      analyticsEventType: eventName,
      analyticsEventData: {
        ...eventData,
        sessionId,
        ptcAccessToken,
      },
    }),
  });
}
